import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IHttpClientService } from '../interfaces';

@Injectable()
export class HttpClientService implements IHttpClientService {
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Accept': 'text/json'
  });

  constructor(
    private http: HttpClient) {
  }

  public get<TResult>(url: string, params: HttpParams = new HttpParams()): TResult {
    return this.http.get(url, { headers: this.headers, params: params }) as TResult;
  }

  public post<TResult, TData>(url: string, data: TData): TResult {
    return this.http.post(url, data, { headers: this.headers }) as TResult;
  }

  public put<TResult, TData>(url: string, data: TData): TResult {
    return this.http.put(url, data, { headers: this.headers }) as TResult;
  }

  public delete<TResult>(url: string): TResult {
    return this.http.delete(url, { headers: this.headers }) as TResult;
  }
}

